export type ApiRequestLog = {
  id: string;
  time: string;
  method: string;
  url: string;
  status?: number;
  ok: boolean;
  duration?: number;
  request?: {
    params?: unknown;
    data?: unknown;
  };
  response?: unknown;
  error?: string;
};

const MAX_LOG_COUNT = 120;
const listeners = new Set<(logs: ApiRequestLog[]) => void>();
let logs: ApiRequestLog[] = [];

const notify = () => {
  listeners.forEach((listener) => {
    listener(logs);
  });
};

export const addApiRequestLog = (log: ApiRequestLog) => {
  if (/\/user\/profile\/password(?:[?#]|$)/.test(log.url) && log.request) {
    log = {
      ...log,
      request: { ...log.request, data: { oldPassword: '******', newPassword: '******' } },
    };
  }
  logs = [log, ...logs].slice(0, MAX_LOG_COUNT);
  notify();
};

export const clearApiRequestLogs = () => {
  logs = [];
  notify();
};

export const getApiRequestLogs = () => logs;

export const subscribeApiRequestLogs = (listener: (nextLogs: ApiRequestLog[]) => void) => {
  listeners.add(listener);
  listener(logs);
  return () => {
    listeners.delete(listener);
  };
};

export const makeRequestLogId = () =>
  `${Date.now()}-${Math.random().toString(16).slice(2)}`;
